import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilePdf, faFileWord, faPrint, faEye, faDownload, faTrashAlt } from '@fortawesome/pro-solid-svg-icons'
import { Button } from './shadcn/Button'

export interface FileCardProps {
  id: string | number
  originalFilename: string
  url: string
  isPdf: boolean
  size?: number | null
  productName?: string
  onView: () => void
  onDownload?: () => void
  onPrint?: () => void
  onDelete?: () => void
  showPrint?: boolean
  showDownload?: boolean
  showDelete?: boolean
}

export const FileCard: React.FC<FileCardProps> = ({
  originalFilename,
  isPdf,
  size,
  productName,
  onView,
  onDownload,
  onPrint,
  onDelete,
  showPrint = false,
  showDownload = false,
  showDelete = false,
}) => {
  const buttons = [
    {
      isShown: showPrint && isPdf && window._depoto,
      icon: faPrint,
      onClick: onPrint,
      text: 'Tisk',
      variant: 'secondary' as const,
    },
    {
      isShown: true,
      icon: faEye,
      onClick: onView,
      text: 'Zobrazit',
      variant: 'outline' as const,
    },
    {
      isShown: showDownload,
      icon: faDownload,
      onClick: onDownload,
      text: 'Stáhnout',
      variant: 'outline' as const,
    },
    {
      isShown: showDelete,
      icon: faTrashAlt,
      onClick: onDelete,
      text: 'Smazat',
      variant: 'outline' as const,
    },
  ].filter(button => button.isShown)

  // First two buttons get flex-1, rest are icon-only
  const primaryButtons = buttons.slice(0, 2)
  const secondaryButtons = buttons.slice(2)

  return (
    <div className="bg-white border border-gray-200 rounded-2xl p-4 shadow-sm hover:shadow-md transition-shadow flex flex-col justify-between">
      {/* File Icon and Name */}
      <div className="flex items-start gap-3 mb-4">
        <div className="flex-shrink-0">
          <FontAwesomeIcon icon={isPdf ? faFilePdf : faFileWord} className="text-2xl text-blue-600" />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-medium text-gray-900 truncate">{originalFilename}</h4>
          {!isPdf && size && <p className="text-xs text-gray-500 mt-1">{`${(Number(size) / 1024).toFixed(2)} KB`}</p>}
          {isPdf && <p className="text-xs text-blue-600 mt-1">PDF dokument</p>}
          {productName && (
            <p className="text-xs text-green-600 mt-1">
              Z produktu: <b>{productName}</b>
            </p>
          )}
        </div>
      </div>

      {/* Action Buttons */}
      <div className="flex gap-2">
        {primaryButtons.map((btn, i) => (
          <Button key={i} variant={btn.variant} size="sm" className="flex-1" icon={btn.icon} onClick={btn.onClick}>
            {btn.text}
          </Button>
        ))}
        {secondaryButtons.map((btn, i) => (
          <Button
            key={i + primaryButtons.length}
            variant={btn.variant}
            size="sm"
            icon={btn.icon}
            onClick={btn.onClick}
          />
        ))}
      </div>
    </div>
  )
}
